import React from 'react';
import { findIndex } from 'lodash';
import { arrayOf, shape, object, string } from 'prop-types';
import { ErrorState } from '../../ErrorState/ErrorState';

export const EmptyCarousel = ({ emptyState = [{ type: '', value: '' }], dataEnrichment }) => {
    const titleIndex = findIndex(emptyState, (item) => item.type === 'text');
    const subtitleIndex = findIndex(emptyState, (item) => item.type === 'text', titleIndex + 1);
    const title = emptyState[titleIndex];
    const subtitle = emptyState[subtitleIndex];
    const buttonData = emptyState.find((item) => item.type === 'button');

    return (
        <ErrorState
            title={title?.value}
            subtitle={subtitle?.value}
            buttonData={buttonData}
            dataEnrichment={dataEnrichment}
        />
    );
};

EmptyCarousel.propTypes = {
    emptyState: arrayOf(
        shape({
            type: string.isRequired,
            value: string.isRequired,
            namedRoute: string,
            url: string,
            urlParams: object,
            queryParams: object,
        })
    ),
    dataEnrichment: object,
};
